<template>
    <section class="blog-left-sidebar-wrapper pb-80px pt-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <blog-sidebar />
                    
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-6" v-for="blog in dlabData.blogData.blogItems" :key="blog.id">
                            <blog-item :item="blog" />
                        </div>
                        <question-pagination layout="prev, pager, next" :totalNumber="100" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import dlabData from '@/store/store.js';
import BlogItem from '../../cards/BlogItem.vue'
import QuestionPagination from '../../dynamic/QuestionPagination.vue';
import BlogSidebar from '../../sidebars/BlogSidebar.vue';
export default {
    components: {
        BlogItem,
        QuestionPagination,
        BlogSidebar,
    },
    name: 'BlogGridNoSidebar',
    data() {
        return {
            dlabData
        }
    }
}
</script>